/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_SupportInputs */

const en_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const de_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const fr_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const es_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

const it_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto`)
};

const nl_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const pl_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie`)
};

const fi_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuki`)
};

const da_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const sv_pricing_compare_support = /** @type {(inputs: Pricing_Compare_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Pricing_Compare_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_support = /** @type {((inputs?: Pricing_Compare_SupportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_SupportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_support(inputs)
	if (locale === "fr") return fr_pricing_compare_support(inputs)
	if (locale === "es") return es_pricing_compare_support(inputs)
	if (locale === "it") return it_pricing_compare_support(inputs)
	if (locale === "nl") return nl_pricing_compare_support(inputs)
	if (locale === "pl") return pl_pricing_compare_support(inputs)
	if (locale === "fi") return fi_pricing_compare_support(inputs)
	if (locale === "da") return da_pricing_compare_support(inputs)
	if (locale === "sv") return sv_pricing_compare_support(inputs)
	return en_pricing_compare_support(inputs)
});